module.exports = __webpack_public_path__ + "static/media/burn-app_2screen.c231df4f.png";